module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    attrs: {
      "id": "latest-matches-panel"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "row columns"
  }), _vm._v(" "), _vm._l((_vm.mrList), function(report) {
    return (_vm.mrList && _vm.mrList.length > 0) ? _c('div', {}, [_c('div', {
      staticClass: "match-panel row columns align-middle lose"
    }, [_c('div', {
      staticClass: "row columns align-middle lose",
      attrs: {
        "id": report.id
      },
      on: {
        "click": function($event) {
          return _vm.gotoDetail(report.id)
        }
      }
    }, [_c('div', {
      staticClass: "large-2 columns"
    }, [_c('img', {
      staticClass: "small-team-icon",
      attrs: {
        "src": _vm.getRosterIcon(report.home_report.roster),
        "alt": "team"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "large-8 columns "
    }, [_vm._v(_vm._s(report.home_report.team.name))]), _vm._v(" "), _c('div', {
      staticClass: "large-1 columns text-centered"
    }, [_vm._v(_vm._s(report.home_report.nb_td))])]), _vm._v(" "), _c('div', {
      staticClass: "row columns win"
    }, [_c('div', {
      staticClass: "large-2 columns"
    }, [_c('img', {
      staticClass: "small-team-icon",
      attrs: {
        "src": _vm.getRosterIcon(report.visitor_report.roster),
        "alt": "team"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "large-8 columns "
    }, [_vm._v(_vm._s(report.visitor_report.team.name))]), _vm._v(" "), _c('div', {
      staticClass: "large-1 columns text-centered"
    }, [_vm._v(_vm._s(report.visitor_report.nb_td))])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('router-link', {
    staticClass: "bottom-link",
    attrs: {
      "to": {
        name: 'matchReportList'
      }
    }
  }, [_vm._v("Tous les matchs...")])], 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n      Les derniers matchs\n        "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f7b52db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/latest-matches-panel.vue
// module id = 729
// module chunks = 0